'use client';

import React, { useState } from 'react';

import WebaliasLink from '@/components/Link/WebaliasLink';
import Button from '@/components/V2/Button';
import Modal from '@/components/V2/Modal';
import Spinner from '@/components/V2/Spinner';
import cn from '@/helpers/utils/classNames';

import { useInterstitialContext } from '../InterstitialModalsContext';
import InterstitialModalCloseButton from './InterstitialModalCloseButton';

const CustomerWelcomeBackModal = () => {
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const { modals, closeModal, data } = useInterstitialContext();

  return (
    <Modal
      isOpen={modals.showWelcomeBackModal}
      onClose={() => closeModal('showWelcomeBackModal')}
      className="v2-w-[712px] md:v2-w-[712px] sm:v2-w-[712px] xs:v2-w-[712px] !v2-p-0"
      closeBtnClassName="v2-top-4 !v2-right-4 v2-w-4 v2-h-4"
      closeButton={props => (
        <InterstitialModalCloseButton
          {...props}
          className={cn(props.className, '!v2-bg-transparent !v2-top-6 md:!v2-top-4 !v2-w-6 !v2-h-6')}
          iconClassName="!v2-invert-0 !v2-h-[24px] !v2-w-[24px]"
        />
      )}
    >
      <div className="v2-w-full v2-px-4 v2-pt-12 v2-pb-4">
        <h2 className="v2-text-2xl v2-font-normal v2-font-sweet-sans-pro v2-text-[#212427] v2-mb-2 md:v2-mb-6">
          {data?.welcomeBackPopup?.heading ?? ''}
        </h2>
        <p className="v2-font-sweet-sans-pro v2-font-normal v2-text-sm v2-text-[#212427] v2-mb-4 md:v2-mb-6">
          {data?.welcomeBackPopup?.description ?? ''}
        </p>
        <WebaliasLink href={data?.welcomeBackPopup.buttonLink || '#'} as={'a'}>
          <Button
            type="button"
            btnSize="md"
            scheme="primary"
            variant="filled"
            className="v2-text-sm v2-leading-[28px] v2-font-sweet-sans-pro-medium v2-font-medium v2-py-[9px] v2-w-full v2-flex v2-justify-center v2-items-center v2-gap-2 v2-mb-0"
            onClick={() => {
              setIsLoadingModal(true);
              closeModal('showWelcomeBackModal');
            }}
            disabled={isLoadingModal}
          >
            {isLoadingModal && <Spinner />}
            {data?.welcomeBackPopup?.buttonText}
          </Button>
        </WebaliasLink>
      </div>
    </Modal>
  );
};

export default CustomerWelcomeBackModal;
